export default [
  {
    key: 'increasement',
    label: '#',
    thClass: 'w-50px',
  },
  {
    key: 'betToolEn',
    label: 'field.nameEn',
    stickyColumn: true,
    variant: 'light',
  },
  {
    key: 'betToolKh',
    label: 'field.nameKh',
  },
  {
    key: 'status',
    label: 'field.status',
  },
  {
    key: 'actions',
    label: 'field.actions',
  },
];
